import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=c5821aa6"
import script from "./main-content.vue?vue&type=script&lang=js"
export * from "./main-content.vue?vue&type=script&lang=js"
import style0 from "./main-content.vue?vue&type=style&index=0&id=c5821aa6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports